import React, {  useState, useEffect }  from "react";
import "./StructureOrganizationPage.css";
import { getStructureTree } from '../../../index';
import { getStructureTreeBancoDeDados } from "../../../app/modules/Auth/_redux/authCrud";
import TreeMenu, { ItemComponent } from 'react-simple-tree-menu';
import { Button }  from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import {ModalOk} from '../../components/ModalOk/ModalOk';
import { getStructureTreeDesativadas } from './actions';

export default function StructureOrganizationPage (props){
	const history = useHistory();
	const [treeData, setTreeData] = useState([{ key: 'test', label: 'Carregando...', nodes: [] }]);
	const [structSelected, setStructSelected] = useState({id:0, label:''});
	const [showModalOk, setShowModalOk] = useState(false);
	const [msgErro, setMsgErro] = useState('');
	const abrirModalOk = (_msg) =>  {setMsgErro(_msg); setShowModalOk(true)};

	const handleSelectTree = async (e) => {
		setStructSelected({id:e.structureId, label:e.label});
	};

	const handleAdicionarFilho = () =>{
		if(structSelected.id){
			history.push(`StructureOrganization/add/${structSelected.id}`);
		}else{
			abrirModalOk('Selecione uma Estrutura');
		}
		
	};

	const handleEditar = () =>{
		if(structSelected.id){
			history.push(`StructureOrganization/edit/${structSelected.id}`);
		}else{
			abrirModalOk('Selecione uma Estrutura');
		}
	};

	useEffect(() => {
		async function initT() {
			const structuresRequest = await getStructureTreeDesativadas();
			const tree = structuresRequest.structures;
			setTreeData(tree);
		}
		initT();
	}, []);

	return(
		<>
			<h1>Estrutura Organizacional</h1>

			{showModalOk ? (<ModalOk tittle={msgErro} ok={e=>setShowModalOk(false)}></ModalOk>):(null)}
			{console.log(treeData[0].key.toString())}
			<div className="tree-menu">
				<TreeMenu
					data={treeData}
					onClickItem={handleSelectTree}
					focused="false"
					hasSearch="true"
					initialOpenNodes={[treeData[0].key.toString()]}
					resetOpenNodesOnDataUpdate={true}
				>
					{({ search, items }) => (
						<ul style={{listStyleType: 'none', padding: '0', margin: '0'}}>
							{items.map(({ key, ...props }) =>
								props.status === false ? (
									<ItemComponent
										style={{ backgroundColor: 'rgba(255,0,0,0.2)' }}
										key={key}
										{...props}
									/>
								) : (
									<ItemComponent 
										key={key} 
										{...props} 
									/>)
							)}
						</ul>
					)}
				</TreeMenu>
			</div>

			<div className="btn-tree">
				<Button variant="warning" className="mr-8" onClick={handleAdicionarFilho}>
					Adicionar Filho
				</Button>

				<Button variant="primary" onClick={handleEditar}>
					Editar
				</Button>
			</div>

			<div>
				<span><b>Legenda:</b></span><br/>
				<span>Branco: Ativos</span><br />
				<span>Rosa: Desativados</span><br />
			</div>

		</>
	)
}